<template lang="pug">
  .component-map
    .container
      GoogleMapContainer
        google-map(
          v-if="mapCenter.lat !== 0 && mapCenter.lng !== 0",
          :searchBar="true",
          :api-key="mapsAPI",
          :center="mapCenter",
          :zoom="13",
          :mapTypeId="'roadmap'",
          :scrollwheel="false",

          :zoomControl="true",
          :mapTypeControl="true",
          ref="map")
          google-map-marker(
            v-if="userPosition",
            :icon="'/static/icon_user_red.png'",
            :position="{lat: userPosition.latitude, lng: userPosition.longitude}",
            :title="''",
            :label="''",
            @click="updateUserPosition"
          )

          google-map-marker(
            v-for='vehicle in vehicles',
            :key='vehicle.plate',
            :icon="'/static/map_pin_blue.png'",
            :position="{lat: vehicle.position.latitude, lng: vehicle.position.longitude}",
            :title="vehicle.distance + ' Km'",
            :label="vehicle.model",
            :labelOrigin="[15,30]",
            @click="updateSelectedVehicle"
          )
            vehicle(:item="vehicle", :type="'quick-booking'", @bookVehicle="$emit('getVehicleSelected', vehicle)")

</template>

<script type="text/babel">
  import GoogleMapContainer from "./GoogleMapContainer";
  import GoogleMap from "../../lib/map/GoogleMap.vue";
  import GoogleMapMarker from "../../lib/map/GoogleMapMarker.vue";
  import GoogleMapCircle from "../../lib/map/GoogleMapCircle";
  import GoogleMapMarkerCluster from "../../lib/map/GoogleMapMarkerCluster";
  import GoogleMapDirectionsService from "../../lib/map/GoogleMapDirectionsService";
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import Vehicle from 'components/backoffice/Vehicle'


  export default {
    name: "BookVehicleFromMap",
    components: {
      GoogleMap,
      GoogleMapMarker,
      GoogleMapCircle,
      GoogleMapMarkerCluster,
      GoogleMapContainer,
      GoogleMapDirectionsService,
      Vehicle,
    },
    data() {
      return {
        vehiclePosition: null,
        userPos: null,
        mapsAPI: null,
        mapCenter: {
          lat: 0,
          lng: 0,
        },
      }

    },
    mounted() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.mapCenter.lat = data.application.application_default_latitude.value
        this.mapCenter.lng = data.application.application_default_longitude.value
      })
      this.mapsAPI = window.env.GOOGLE_MAPS_KEY
    },

    methods: {
      updateUserPosition(position) {
        this.userPosition = position.location
      },
      updateSelectedVehicle(position) {
        this.vehiclePosition = position.latLng
      },
    },
    watch: {
      userPosition: function () {
        if (this.userPosition) {
          this.mapCenter.lat = this.userPosition.latitude
          this.mapCenter.lng = this.userPosition.longitude
        }
      },
    },
    props: {
      vehicles: Array,
      userPosition: null
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-map
    width: 100%

    .toggles
      position: absolute
      padding: 2em
      right: 0
      background: white
      width: 300px

      .content
        display: flex
        text-align: center
        flex-direction: column
        justify-content: center
</style>





// WEBPACK FOOTER //
// BookVehicleFromMap.vue?442fd533